import { useRef } from 'react';
import { Camera } from '@phosphor-icons/react/dist/ssr/Camera';

/**
 * CameraButton — shared camera icon + hidden file input for chat image capture.
 *
 * On iOS Safari, accept="image/*" without capture shows the native chooser:
 * Take Photo (top option), Photo Library, Choose File.
 * No capture attribute — that would force camera-only and lock out the library.
 *
 * Used by: ChatInputSharing (chat stage), ChatInputNormal
 */
const CameraButton = ({ onTakePhoto }) => {
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onTakePhoto(file);
    }
    // Reset so the same file can be selected again
    e.target.value = '';
  };

  return (
    <>
      <div
        onClick={handleClick}
        style={{
          flexShrink: 0,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '40px',
          height: '40px',
          marginRight: '14px',
        }}
      >
        <Camera size={28} weight="light" color="#888888" />
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </>
  );
};

export default CameraButton;
